// src/stores/profile-store.js — Reactive profile state store
export const ProfileStore = (function() {
    const _state = {
        profiles: [],
        profilesEnabled: false,
        currentProfileId: null,
        currentDisplayName: null,
        currentColor: null,
        isAdmin: false,
    };
    const _subscribers = {};

    function _notify(key) {
        (_subscribers[key] || []).forEach(function(fn) { try { fn(_state[key]); } catch(e) {} });
        (_subscribers['*'] || []).forEach(function(fn) { try { fn(key, _state[key]); } catch(e) {} });
    }

    return {
        get: function(key) { return _state[key] !== undefined ? _state[key] : null; },
        set: function(key, value) {
            if (_state[key] === value) return;
            _state[key] = value;
            _notify(key);
        },
        setAll: function(obj) {
            Object.entries(obj).forEach(function(entry) { _state[entry[0]] = entry[1]; });
            Object.keys(obj).forEach(function(k) { _notify(k); });
        },
        on: function(key, fn) {
            if (!_subscribers[key]) _subscribers[key] = [];
            _subscribers[key].push(fn);
            return function() { _subscribers[key] = _subscribers[key].filter(function(f) { return f !== fn; }); };
        },
        getCurrentProfile: function() {
            var id = _state.currentProfileId;
            if (!id || !_state.profiles) return null;
            return _state.profiles.find(function(p) { return p.profileId === id; }) || null;
        },
        persistSession: function() {
            if (_state.currentProfileId) {
                sessionStorage.setItem('dentscribe_profileId', _state.currentProfileId || '');
                sessionStorage.setItem('dentscribe_profileDisplayName', _state.currentDisplayName || '');
                sessionStorage.setItem('dentscribe_profileColor', _state.currentColor || '#4A90D9');
                sessionStorage.setItem('dentscribe_isProfileAdmin', _state.isAdmin ? '1' : '0');
            } else {
                sessionStorage.removeItem('dentscribe_profileId');
                sessionStorage.removeItem('dentscribe_profileDisplayName');
                sessionStorage.removeItem('dentscribe_profileColor');
                sessionStorage.removeItem('dentscribe_isProfileAdmin');
            }
        },
        restoreSession: function() {
            var id = sessionStorage.getItem('dentscribe_profileId');
            if (id) {
                _state.currentProfileId = id;
                _state.currentDisplayName = sessionStorage.getItem('dentscribe_profileDisplayName') || '';
                _state.currentColor = sessionStorage.getItem('dentscribe_profileColor') || '#4A90D9';
                _state.isAdmin = sessionStorage.getItem('dentscribe_isProfileAdmin') === '1';
            }
        },
        clear: function() {
            _state.profiles = [];
            _state.profilesEnabled = false;
            _state.currentProfileId = null;
            _state.currentDisplayName = null;
            _state.currentColor = null;
            _state.isAdmin = false;
            this.persistSession();
            _notify('currentProfileId');
            _notify('profiles');
        },
    };
})();
